import logoAward from '../assets/svg/logo/logo-and-award.svg';
import logo from '../assets/svg/logo/logo-only.svg';
import textAward from "../assets/svg/logo/text-and-award.svg";
import textLogo from '../assets/svg/logo/text-and-logo.svg';
import textClipartAward from "../assets/svg/logo/text-clipart-award.svg";
import textLogoAward from '../assets/svg/logo/text-logo-award.svg';
import text from '../assets/svg/logo/text-only.svg';

export const logoData = [{
    id: "logoAward",
    imageSrc: logoAward,
    alt: "logo-award",
    label: "Logo Award",
}, {
    id: "logo",
    imageSrc: logo,
    alt: "logo",
    label: "Logo",
},
{
    id: "textAward",
    imageSrc: textAward,
    alt: "text-award",
    label: "Text Award",
},
 {
    id: "textLogo",
    imageSrc: textLogo,
    alt: "text-logo",
    label: "Text Logo",
}, {
    id: "textClipartAward",
    imageSrc: textClipartAward,
    alt: "text-clipart-award",
    label: "Text Clipart Award",
},
{
    id: "textLogoAward",
    imageSrc: textLogoAward,
    alt: "text-logo-award",
    label: "Text Logo Award",
}, {
    id: "text",
    imageSrc: text,
    alt: "text",
    label: "Text",
}];